export default __webpack_public_path__ + "static/media/poweredBy.0016d23d.svg";